// extracted by mini-css-extract-plugin
export default {"PokemonCard":"PokemonCard_PokemonCard__YW690","content":"PokemonCard_content__l-esN","type":"PokemonCard_type__GW4fI"};